import { SiteUrls } from '@tableau/shared-urls';
import React from 'react';
import { Route } from 'react-router';
import { defaultMemoize } from 'reselect';
import { BreadcrumbStateInfo, SiteUrlsContext } from '../../../data-catalog-shared';
import { createCatalogDatabasesBreadcrumb } from './BreadcrumbFactories';
import { BreadcrumbsUpdater } from './BreadcrumbsUpdater';

function createDatabasesBreadcrumbsList(
  urls: SiteUrls,
  urlSuffix: string,
): ReadonlyArray<BreadcrumbStateInfo> {
  return [
    createCatalogDatabasesBreadcrumb(urls, urlSuffix)
  ];
}

export type DatabasesBreadcrumbsUpdaterProps = {
};

export class DatabasesBreadcrumbsUpdater extends React.Component<DatabasesBreadcrumbsUpdaterProps> {

  private readonly memoizedCreateDatabasesBreadcrumbsList = defaultMemoize(createDatabasesBreadcrumbsList);

  public override render() {
    return (
      <SiteUrlsContext.Consumer>
        {urls =>
          <Route>
            {({ location }) => {
              const breadcrumbs = this.memoizedCreateDatabasesBreadcrumbsList(urls, location.search);
              return (
                <BreadcrumbsUpdater breadcrumbs={breadcrumbs} />
              );
            }}
          </Route>
        }
      </SiteUrlsContext.Consumer>
    );
  }

}
